import styled from "styled-components";
import "../../index.scss";
import "../../styles/sass/Pages/_newDesign.scss";

export const ContainerRouter = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	height: 100vh;
	align-items: center;
	background: var(--neutral-stronger);

	@media only screen and (max-width: 900px) {
		flex-direction: column;
		background: var(--neutral-strongest);
		height: auto;
	}
`;

export const Container = styled.div`
	width: 50%;
	height: 100%;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	align-items: center;
	padding: 1rem 0;

	overflow-x: auto;

	@media only screen and (max-width: 900px) {
		width: 100%;
		overflow-x: unset;
	}

	@media only screen and (max-width: 380px) {
		height: 40rem;
	}
`;

/**@deprecated */
export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	align-content: center;
	height: 100%;
	justify-content: flex-end;

	@media only screen and (max-width: 900px) {
		flex-direction: column;
	}
`;

/**@deprecated */
export const Box = styled.div`
	width: 50%;
	display: flex;
	justify-content: center;

	@media only screen and (max-width: 800px) {
		width: 100%;
	}

	@media only screen and (max-width: 380px) {
		width: 85%;
	}
`;

export const Content = styled.section`
	width: 27rem;
	font-family: "MetropolisRegular";
	padding: 1rem 0;

	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	gap: 2rem;

	@media only screen and (max-width: 900px) {
		width: 100%;
		max-width: 23rem;
		overflow-x: unset;
	}

	@media only screen and (max-width: 380px) {
		width: 85%;
	}
`;

export const HeaderContent = styled.div`
	display: flex;
	flex-direction: column;
`;

export const Title = styled.span`
	color: #ffffff;
	font-size: 24px;
	font-family: var(--font-family-metropolis-semi-bold);
	width: 100%;
`;

export const Subtitle = styled.span.withConfig({ shouldForwardProp: (props) => props !== "visibility" })`
	font-size: 16px;
	color: #ffffff;
	font-family: "MetropolisRegular";
	line-height: 150%;

	display: ${(props) => props.visibility};

	button {
		color: #01e59b;
		font-family: var(--font-family-metropolis-semi-bold);
		outline: none !important;
		background: none;
		border: none;

		&:hover {
			text-decoration: underline;
		}
	}

	b {
		font-family: var(--font-family-metropolis-semi-bold);
	}
`;

export const Col = styled.div`
	display: flex;
	flex-direction: column;
`;

export const Label = styled.label`
	font-size: 12px;
	font-family: "MetropolisRegular";
	color: #ffffff;
`;

/** @deprecated */
export const ContainerPinCode = styled.div`
	padding-top: 13px;
	width: 100%;

	@media only screen and (max-width: 900px) {
		display: flex;
		align-items: flex-start;
		justify-content: center;
		flex-direction: column;
	}
`;

export const FormGroupInput = styled.div`
	position: relative;
	width: 100%;
`;

export const MessageError = styled.span`
	width: 100% !important;
	color: var(--feedback-error);
	font-size: var(--font-size-small);
	font-family: var(--font-family-metropolis);
	font-weight: 600;
	margin: 0.3rem 0;
`;

// ________________________________________ CONFIRM_PINCODE ________________________________________

/** @deprecated */
export const ButtonContainer = styled.div`
	margin-top: 40px;
	width: 100%;
`;

/** @deprecated */
export const TextResend = styled.label`
	font-size: 16px;
	font-family: "MetropolisRegular";
	color: #ffffff;
`;

/** @deprecated */
export const DivButtonConfirm = styled.div`
	display: flex;
	justify-content: ${(props) => (props.type ? "center" : "space-between")};
	font-family: var(--font-family-metropolis-semi-bold);
`;

/** @deprecated */
export const DivTimer = styled.div`
	display: flex;
	justify-content: center;
	font-family: "MetropolisRegular";
	margin-top: 48px;
	width: 100%;

	span {
		color: #01e59b;
		font-size: 16px;
	}
`;

export const HelpContainer = styled.div`
	margin-top: 1.5rem;
`;

export const TitleHelp = styled.div.withConfig({ shouldForwardProp: (props) => props !== "visibility" })`
	color: #ffffff;
	font-size: 20px;
	font-family: var(--font-family-metropolis-semi-bold);
	width: 100%;
	padding-bottom: 0.5rem;

	display: ${(props) => props.visibility};
`;

export const FormSupport = styled.form`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	overflow-x: auto;
`;

export const FormSubmit = styled.div`
	width: 100%;
`;
